import { render, staticRenderFns } from "./dynamic-document-year-month-brick-template.vue?vue&type=template&id=c6db8e16&"
import script from "./dynamic-document-year-month-brick-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-year-month-brick-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports